const IS_LOADING = "list/timesOfDay/IS_LOADING";
const IS_PARTIAL_LOADING = "list/timesOfDay/IS_PARTIAL_LOADING";
const IS_ERROR = "list/timesOfDay/IS_ERROR";
const DATA = "list/timesOfDay/DATA";
const EDIT = "list/timesOfDay/EDIT";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, DATA, EDIT };
